export default function backToPreviousPage() {
	/*
	 *
	 * Go Back to Previous Page
	 *
	 */
	const backButtonElement = document.getElementById('roc-back-btn');
	if (backButtonElement) {
		backButtonElement.addEventListener('click', function () {
			window.history.back();
		});
	}
}
